import { render, staticRenderFns } from "./CooperationSystemTable.vue?vue&type=template&id=57671d32&lang=pug"
import script from "./CooperationSystemTable.vue?vue&type=script&lang=ts"
export * from "./CooperationSystemTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports